import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './CookieConsent.css';

function CookieConsent() {
  const { t } = useTranslation();
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    // Check if user has already given consent
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      // Show consent banner after a short delay
      setTimeout(() => {
        setShowConsent(true);
      }, 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowConsent(false);
    
    // Trigger ad initialization after consent
    // Ad components will check consent and initialize automatically
    // Dispatch a custom event to notify ad components
    window.dispatchEvent(new Event('cookieConsentAccepted'));
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    localStorage.setItem('cookieConsentDate', new Date().toISOString());
    setShowConsent(false);
  };

  const handleCustomize = () => {
    // Open cookie preferences modal or navigate to cookie settings
    window.location.href = '/cookies';
  };

  if (!showConsent) {
    return null;
  }

  return (
    <div className="cookie-consent">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <h3>{t('cookies.title')}</h3>
          <p>{t('cookies.message')}</p>
          <div className="cookie-links">
            <a href="/privacy">{t('cookies.privacyPolicy')}</a>
            <span> • </span>
            <a href="/cookies">{t('cookies.learnMore')}</a>
          </div>
        </div>
        <div className="cookie-consent-buttons">
          <button 
            className="cookie-btn cookie-btn-accept" 
            onClick={handleAccept}
            aria-label={t('cookies.accept')}
          >
            {t('cookies.accept')}
          </button>
          <button 
            className="cookie-btn cookie-btn-reject" 
            onClick={handleReject}
            aria-label={t('cookies.reject')}
          >
            {t('cookies.reject')}
          </button>
          <button 
            className="cookie-btn cookie-btn-customize" 
            onClick={handleCustomize}
            aria-label={t('cookies.customize')}
          >
            {t('cookies.customize')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
